import React, { useState } from 'react'
import "./SideBar.scss"
import { useNavigate } from 'react-router-dom';
import MenuNav from '@/shared/ui/Navs/MenuNavs'
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import PeopleIcon from '@mui/icons-material/People';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useAuth } from '@/app/context/AuthContext';

export const SideBarNav = () => {
    const navigate = useNavigate();
    const { isSuperAdmin } = useAuth();
    const currentPath = window.location.pathname;

    const paths = [
        { path: "/projects", icon: <FolderOpenIcon fontSize="small" />, label: "Проекты" },
        ...(isSuperAdmin ? [{ path: "/employees", icon: <PeopleIcon fontSize="small" />, label: "Сотрудники" }] : []),
    ];

    return (
        <>
            {paths.map(el => (
                <MenuNav
                    key={el.path}
                    onClick={() => navigate(el.path)}
                    active={currentPath === el.path || currentPath === el.path + "/"}
                    title={el.label}
                >
                    {el.icon}
                    <span className="SideBarNavText">{el.label}</span>
                </MenuNav>
            ))}
        </>
    )
}

function SideBar({children}: any) {
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();
    return (
        <nav className={`SideBar${collapsed ? ' SideBar--collapsed' : ''}`}>
            <nav className='SideBarNav'>
                {children || <SideBarNav/>}
            </nav>
            <div className='SideBarNav__bottom'>
                <div onClick={() => { navigate("/signin");}}>
                    <span className='SideBarNavText text-14 cursor-pointer' style={{color: "white"}}>Выйти</span>
                </div>
                <button className='SideBar__toggle' onClick={() => setCollapsed(c => !c)}>
                    {collapsed ? <ChevronRightIcon fontSize="small" /> : <ChevronLeftIcon fontSize="small" />}
                </button>
            </div>
        </nav>
    )
}

export default SideBar;